import { GET_LABOR, CREATE_LABOR, UPDATE_LABOR, DELETE_LABOR, GET_BULK_LABOR, REORDER_LABOR } from './labor.types';

export const laborActions = {
  getLabor: (taskId) => ({ type: GET_LABOR, payload: taskId }),
  createLabor: (data) => ({ type: CREATE_LABOR, payload: data }),
  updateLabor: (id, data) => ({ type: UPDATE_LABOR, payload: { id, data } }),
  deleteLabor: (id) => ({ type: DELETE_LABOR, payload: id }),
  getBulkLabor: (taskIds) => ({ type: GET_BULK_LABOR, payload: taskIds }),
  reorderLabor: (items) => ({ type: REORDER_LABOR, payload: items }),
};
